import React from 'react'

import './SectionHeaderRow.scss'
import classNames from 'classnames'

export const SectionHeaderRow = (props: {
  children?: React.ReactNode
  divider?: boolean
  title?: string
}) => {
  const { children, divider, title } = props

  return (
    <div className={classNames('SectionHeaderRow', { divider })}>
      <div className="listHeaderContent">
        {title && (
          <h3 style={{ flexGrow: 1 }}>{title}</h3>
        )}
        {children}
      </div>
    </div>
  )
}